module.exports = __webpack_public_path__ + "static/logo-ec04d2525b08ad480154aad577ab795d.png";